import axios from 'axios';

const API_BASE_URL = 'https://lellahom.com/api/api';
//const API_BASE_URL = 'http://192.168.1.12:3002/api';
//const API_BASE_URL = 'https://cb1089625008dc15-196-238-33-146.serveousercontent.com/api';
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      window.location.href = '/loginSignUp';
    }
    return Promise.reject(error);
  }
);

// --- Auth APIs ---
export const authAPI = {
  register: (userData) => api.post('/auth/register', userData),
  login: (credentials) => api.post('/auth/login', credentials),
  verifyEmail: (email, otp) => api.post('/auth/verify-email', { email, otp }),
  forgotPassword: (email) => api.post('/auth/forgot-password', { email }),
  resetPassword: (email, otp, newPassword) => api.post('/auth/reset-password', { email, otp, newPassword }),
  resendVerification: (email) => api.post('/auth/resend-verification', { email }),
};

// --- User APIs ---
export const userAPI = {
  getAll: () => api.get('/users'),
  getById: (id) => api.get(`/users/${id}`),
  create: (userData) => api.post('/users', userData),
  update: (id, userData) => api.put(`/users/${id}`, userData),
  delete: (id) => api.delete(`/users/${id}`),
  login: (credentials) => api.post('/users/login', credentials),
  getMe: () => api.get('/users/me/profile'),
  updatePromo: (promoCode) => api.put('/users/me/promo', { promo_code: promoCode }),
};

// --- Product APIs ---
export const productAPI = {
  getAll: () => api.get('/products'),
  getById: (id) => api.get(`/products/${id}`),
  create: (productData) => api.post('/products', productData),
  update: (id, productData) => api.put(`/products/${id}`, productData),
  delete: (id) => api.delete(`/products/${id}`),
};

// --- Category APIs ---
export const categoryAPI = {
  getAll: () => api.get('/categories'),
  getById: (id) => api.get(`/categories/${id}`),
  create: (categoryData) => api.post('/categories', categoryData),
  update: (id, categoryData) => api.put(`/categories/${id}`, categoryData),
  delete: (id) => api.delete(`/categories/${id}`),
};

// --- Gender Category APIs ---
export const genderCategoryAPI = {
  getAll: () => api.get('/gender-categories'),
  getById: (id) => api.get(`/gender-categories/${id}`),
  create: (data) => api.post('/gender-categories', data),
  update: (id, data) => api.put(`/gender-categories/${id}`, data),
  delete: (id) => api.delete(`/gender-categories/${id}`),
};

// --- Size APIs ---
export const sizeAPI = {
  getAll: () => api.get('/sizes'),
  getById: (id) => api.get(`/sizes/${id}`),
  create: (data) => api.post('/sizes', data),
  update: (id, data) => api.put(`/sizes/${id}`, data),
  delete: (id) => api.delete(`/sizes/${id}`),
};

// --- Order APIs ---
export const orderAPI = {
  getAll: () => api.get('/orders'),
  getById: (id) => api.get(`/orders/${id}`),
  create: (data) => api.post('/orders', data),
  update: (id, data) => api.put(`/orders/${id}`, data),
  delete: (id) => api.delete(`/orders/${id}`),
  updateStatus: (id, status) => api.patch(`/orders/${id}/status`, { status }),
  getStats: () => api.get('/orders/stats'),
  getUserOrders: (userId) => api.get(`/users/${userId}/orders`),
};

// --- Wishlist APIs ---
export const wishlistAPI = {
  addToWishlist: (productId) => api.post('/wishlist', { product_id: productId }),
  getWishlist: () => api.get('/wishlist'),
  removeFromWishlist: (productId) => api.delete(`/wishlist/${productId}`),
  checkWishlistStatus: (productId) => api.get(`/wishlist/check/${productId}`),
};
// --- Promo/Roulette APIs ---
export const rouletteAPI = {
  getConfig: () => api.get('/roulette/config'),
  savePrize: (data) => api.post('/promos/save-win', data),
};
export default api;
